export const payment_details = [
  {
    key:"1",
    Invoice_ID: "Inv-001",
    Image: "user-39.jpg",
    Client_Name: "Michael Walker",
    Roll: "CEO",
    Company_Name: "BrightWave Innovations",
    Payment_Type: "Paypal",
    Paid_Date: "15 Jan 2024",
    Paid_Amount: "$3000",
  },
  {
    key:"2",
    Invoice_ID: "Inv-002",
    Image: "user-40.jpg",
    Client_Name: "Sophie Headrick Manager",
    Roll: "Manager",
    Company_Name: "Stellar Dynamics",
    Payment_Type: "Paypal",
    Paid_Date: "25 Jan 2024",
    Paid_Amount: "$2500",
  },
  {
    key:"3",
    Invoice_ID: "Inv-003",
    Image: "user-41.jpg",
    Client_Name: "Cameron Drake Director",
    Roll: "Director",
    Company_Name: "Quantum Nexus",
    Payment_Type: "Paypal",
    Paid_Date: "22 Feb 2024",
    Paid_Amount: "$2800",
  },
  {
    key:"4",
    Invoice_ID: "Inv-004",
    Image: "user-42.jpg",
    Client_Name: "Doris Crowley Consultant",
    Roll: "Consultant",
    Company_Name: "EcoVision Enterprises",
    Payment_Type: "Paypal",
    Paid_Date: "17 Mar 2024",
    Paid_Amount: "$3300",
  },
  {
    key:"5",
    Invoice_ID: "Inv-005",
    Image: "user-43.jpg",
    Client_Name: "Thomas Bordelon",
    Roll: "Manager",
    Company_Name: "Aurora Technologies",
    Payment_Type: "Paypal",
    Paid_Date: "16 Apr 2024",
    Paid_Amount: "$3600",
  },
  {
    key:"6",
    Invoice_ID: "Inv-006",
    Image: "user-44.jpg",
    Client_Name: "Kathleen Gutierrez",
    Roll: "Director",
    Company_Name: "BlueSky Ventures",
    Payment_Type: "Paypal",
    Paid_Date: "21 May 2024",
    Paid_Amount: "$2000",
  },
  {
    key:"7",
    Invoice_ID: "Inv-007",
    Image: "user-45.jpg",
    Client_Name: "Bruce Wright",
    Roll: "CEO",
    Company_Name: "TerraFusion Energy",
    Payment_Type: "Paypal",
    Paid_Date: "06 Jul 2024",
    Paid_Amount: "$3400",
  },
  {
    key:"8",
    Invoice_ID: "Inv-008",
    Image: "user-46.jpg",
    Client_Name: "Estelle Morgan",
    Roll: "Manager",
    Company_Name: "UrbanPulse Design",
    Payment_Type: "Paypal",
    Paid_Date: "04 Sep 2024",
    Paid_Amount: "$4000",
  },
  {
    key:"9",
    Invoice_ID: "Inv-009",
    Image: "user-47.jpg",
    Client_Name: "Stephen Dias",
    Roll: "CEO",
    Company_Name: "Nimbus Networks",
    Payment_Type: "Paypal",
    Paid_Date: "15 Nov 2024",
    Paid_Amount: "$4500",
  },
  {
    key:"10",
    Invoice_ID: "Inv-010",
    Image: "user-48.jpg",
    Client_Name: "Angela Thomas",
    Roll: "Consultant",
    Company_Name: "Epicurean Delights",
    Payment_Type: "Paypal",
    Paid_Date: "11 Dec 2024",
    Paid_Amount: "$3800",
  },
];
